"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CalendarFrom = function CalendarFrom(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: ref
  }, props), (0, _core.jsx)("path", {
    d: "M25.618 21.553a1.41 1.41 0 011.399 1.432v4.307a5.509 5.509 0 0011.017-.154v-4.164a1.41 1.41 0 011.41-1.421H53.16a1.411 1.411 0 011.41 1.465v4.407a5.508 5.508 0 005.509 5.21l.216-.004a5.509 5.509 0 005.292-5.504v-4.142a1.41 1.41 0 011.41-1.432h4.11a5.508 5.508 0 015.486 5.508v46.8a5.508 5.508 0 01-5.508 5.508H21.508A5.508 5.508 0 0116 73.861v-46.8l.004-.216a5.509 5.509 0 015.504-5.292zm44.024 22.033H22.908a1.378 1.378 0 00-1.377 1.422v27.586c0 .76.616 1.377 1.377 1.377h46.734c.76 0 1.377-.616 1.377-1.377v-27.63c0-.761-.617-1.378-1.377-1.378zm-32.469 4.628c.757 0 1.37.613 1.37 1.37v9.26a1.37 1.37 0 01-1.37 1.37h-9.26a1.37 1.37 0 01-1.37-1.37v-9.26c0-.757.614-1.37 1.37-1.37h9.26zm-4.637-32.18a2.754 2.754 0 012.755 2.753v8.274a2.755 2.755 0 01-5.509.088v-8.362a2.754 2.754 0 012.754-2.754zM60.08 16a2.754 2.754 0 012.754 2.754v8.307a2.754 2.754 0 01-5.508.055v-8.362A2.754 2.754 0 0160.079 16z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(CalendarFrom);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CalendarFrom, "CalendarFrom", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CalendarFrom.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CalendarFrom.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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